import { createSlice } from '@reduxjs/toolkit';
import { Modules, Strategies, UserGroup } from './userGroupModel';
import {
  editUserGroupThunk,
  getGroupDetailsThunk,
  getModulesThunk,
  getUserGroupsThunk,
  saveUserGroupThunk,
} from './userGroupActions';

export interface UserGroupData {
  loading: boolean;
  data: UserGroup[];
  modules: Modules[];
  strategies: Strategies[];
  selectedGroupDetails: UserGroup;
}

const initialState: UserGroupData = {
  loading: false,
  data: null,
  modules: [],
  strategies: [],
  selectedGroupDetails: null,
};

const userGroupSlice = createSlice({
  name: 'User Group',
  initialState,
  reducers: {
    clearUserGroups: (state) => {
      state.data = null;
    },
    clearSelectedGroupDetails: (state) => {
      state.selectedGroupDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserGroupsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserGroupsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload || [];
      })
      .addCase(getUserGroupsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getGroupDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGroupDetailsThunk.fulfilled, (state, action) => {
        const selectedGroupDetails: UserGroup = action.payload;
        state.selectedGroupDetails = selectedGroupDetails;
        state.loading = false;
      })
      .addCase(getGroupDetailsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveUserGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveUserGroupThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(saveUserGroupThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(editUserGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(editUserGroupThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editUserGroupThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getModulesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getModulesThunk.fulfilled, (state, action) => {
        state.modules = action.payload?.data?.allModules || [];
        state.loading = false;
      })
      .addCase(getModulesThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearUserGroups, clearSelectedGroupDetails } = userGroupSlice.actions;
export default userGroupSlice.reducer;
